import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/fonts/Roboto-Regular.ttf';
import './assets/fonts/Roboto-Thin.ttf';
import './assets/fonts/Roboto-Medium.ttf';
import ScrollToTop from './ScrollToTop';
import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
    <StrictMode>
        <Router>
            <ScrollToTop />
            <App />
        </Router>
    </StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
